import React, { useState } from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  Button,
  Box,
} from "@mui/material";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es"; // Importar español para dayjs
import dayjs from "dayjs";

const InventarioSoportes = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    infracciones: false,
    salud: false,
    sistemaTratamiento: "",
    criterioArchivo: "",
    lugarAlmacenamiento: "",
    fechaAlta: dayjs(),
    mecanismoCifrado: "",
  });

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      fechaAlta: date,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(formData);
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: "auto",
        p: 3,
        backgroundColor: "#f5f5f5",
        borderRadius: 2,
      }}
    >
      <p style={{ fontSize: "13px", color: "gray", marginBottom: "25px" }}>
        Ficha para registrar los datos de cualquier soporte físico que contenga
        información de carácter personal y se utilice en el desempeño de la
        actividad profesional, como programas de gestión, iPads, smartphones,
        portátiles, pendrives, documentación en papel o correos electrónicos.
      </p>
      {/* Checkboxes */}
      <FormControlLabel
        control={
          <Checkbox
            name="infracciones"
            checked={formData.infracciones}
            onChange={handleChange}
          />
        }
        label="¿Almacena datos de carácter personal relativos a infracciones penales y administrativas?"
      />
      <FormControlLabel
        control={
          <Checkbox
            name="salud"
            checked={formData.salud}
            onChange={handleChange}
          />
        }
        label="¿Almacena datos de carácter personal relativos a salud, accidentes de tráfico, lesiones, agresiones sexuales, abusos…?"
      />

      {/* Select - Sistema de Tratamiento */}
      <FormControl fullWidth margin="normal">
        <InputLabel>Sistema de Tratamiento</InputLabel>
        <Select
          name="sistemaTratamiento"
          value={formData.sistemaTratamiento}
          onChange={handleChange}
        >
          <MenuItem value="Automatizado">Automatizado</MenuItem>
          <MenuItem value="Manual">Manual</MenuItem>
          <MenuItem value="Mixto">Mixto</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal">
        <InputLabel>Criterio de Archivo</InputLabel>
        <Select
          name="criterioArchivo"
          value={formData.criterioArchivo}
          onChange={handleChange}
        >
          <MenuItem value="Alfabético">Alfabético</MenuItem>
          <MenuItem value="Fechas">Fechas</MenuItem>
          <MenuItem value="Numeración">Numeración</MenuItem>
        </Select>
      </FormControl>

      {/* Lugar de Almacenamiento */}
      <TextField
        fullWidth
        label="Lugar de Almacenamiento"
        name="lugarAlmacenamiento"
        value={formData.lugarAlmacenamiento}
        onChange={handleChange}
        margin="normal"
      />

      {/* Fecha de Alta */}
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <DesktopDatePicker
          sx={{ width: "100%" }}
          views={["year", "month"]}
          label="Fecha de Alta (Mes y Año)"
          value={formData.fechaAlta}
          onChange={handleDateChange}
          format="MM/YYYY"
        />
      </LocalizationProvider>
      <TextField
        fullWidth
        label="Mecanismo de Cifrado (si aplica)"
        name="mecanismoCifrado"
        value={formData.mecanismoCifrado}
        onChange={handleChange}
        margin="normal"
        helperText="Rellenar en caso de que el dispositivo almacene los datos cifrados o tenga algún método análogo de seguridad."
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        Guardar Información
      </Button>
    </Box>
  );
};

export default InventarioSoportes;
